import { postBiz, json, rows } from '../core/coreapi';
const SERVICE = 'biehistorical';

export const fetchHistoricalCards = async () =>
  json(await postBiz({ s: 'biehistorical', a: 'cards' }));

export const fetchHistoricalImports = async (f: any) =>
  rows(
    await postBiz({
      s: 'biehistorical',
      a: 'imports',
      soc: f.sourcecode || null,
      sts: f.status ?? null,
      pos: f.page || 0,
      plm: f.pagesize || 50,
    })
  );

export const fetchHistoricalFacts = async (f: any) =>
  rows(
    await postBiz({
      s: 'biehistorical',
      a: 'facts',
      scc: f.scenariocode || null,
      dsc: f.datasetcode || null,
      pdc: f.periodcode || null,
      pos: f.page || 0,
      plm: f.pagesize || 100,
    })
  );

export const uploadHistoricalData = async (payload: any) =>
  json(await postBiz({ s: 'biehistorical', a: 'upload', ...payload }));

export const validateHistoricalImport = async (importid: number) =>
  json(await postBiz({ s: 'biehistorical', a: 'validate', rid: importid }));

export const publishHistoricalImport = async (importid: number) =>
  json(await postBiz({ s: 'biehistorical', a: 'publish', rid: importid }));
